import { OrderTypeOptions, type TOrderTypeOptions } from '@interfaces/order'

export * from './oderTemplate'
export * from './settingComponentRegistry'
export * from './settingComponentMap'

export const OrderDetailActionConstant = Object.entries(OrderTypeOptions).map(
  ([label, value]) => ({
    label: label as keyof typeof OrderTypeOptions,
    value: value as TOrderTypeOptions,
  }),
)
export const PlanOptions = {
  Free: 'FREE',
  Starter: 'STARTER',
  Professional: 'PROFESSIONAL',
  Premium: 'PREMIUM',
} as const
export type TPlanOptions = (typeof PlanOptions)[keyof typeof PlanOptions]

export const defaultPageNumber = 1
export const defaultPageSize = 10
